import { imgItems } from '@elem/compPage/stream-series-plug-in-solar-battery/pages/product/components/EcoAi/config';

interface Item {
    pc: string;
    pcPoster: string;
    h5: string;
    h5Poster: string;
}
type VideoLocaleMap = Partial<
    Record<
        'us' | 'ca' | 'eu' | 'uk' | 'de' | 'fr' | 'it' | 'es' | 'nl',
        {
            max: {
                double: Item;
                single: Item;
            };
            ultra?: {
                double: Item;
                single: Item;
            };
        }
    >
>;

const videoLocaleMap: VideoLocaleMap = {
    us: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758177785342/PC-01-%E5%8F%8C%E8%B7%AF.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1758871442283-vg68xa-compressed-%E5%8F%8C%E8%B7%AF-%E9%9D%99%E6%80%81.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758177733638/M-D3M-01-%E5%8F%8C%E8%B7%AF.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871491911-3dab77-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758177785844/PC-02-%E5%8D%95%E8%B7%AF.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871471931-i1q269-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758269481028/M-D3M-02-%E5%8D%95%E8%B7%AF.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871507927-7oa8yj-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91%E5%B0%81%E9%9D%A2.jpg',
            },
        },
        ultra: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758177843812/PC-D3U-01-%E5%8F%8C%E8%B7%AF.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871535159-tk533i-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758177879231/M-D3U-01-%E5%8F%8C%E8%B7%AF.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1758871566375-ugxzkq-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1758177843906/PC-D3U-02-%E5%8D%95%E8%B7%AF.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1758871550195-rwptb6-compressed-PC-D3U-%E5%8D%95%E8%B7%AF-%E9%9D%99%E6%80%81.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1758177879497/M-D3U-02-%E5%8D%95%E8%B7%AF.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1758871618542-cgmcjf-compressed-M-D3U-%E5%8D%95%E8%B7%AF-%E9%9D%99%E6%80%81.jpg',
            },
        },
    },

    eu: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761639538860/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286855287-jyp6sa-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640490035/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286907294-enwbcx-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761640767491/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286875442-evmgt4-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640790180/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286917103-m9ax27-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF.jpg',
            },
        },
    },
    nl: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761639538860/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286855287-jyp6sa-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640490035/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286907294-enwbcx-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761640767491/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286875442-evmgt4-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640790180/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286917103-m9ax27-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF.jpg',
            },
        },
    },
    de: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761640831106/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_DE_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620504130-ki9km0-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91-de.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640926591/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_DE_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761620927515-9vs2b6-compressed-M-D3M-01-%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761640830836/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_DE_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                pcPoster: 'https://websiteoss.ecoflow.com/figma-uploads/1761620515262-jq1n3b-compressed-%E5%8D%95%E8%B7%AF-%E9%9D%99%E6%80%81.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640886500/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_DE_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761620938205-dm2rj5-compressed-%E5%8D%95%E8%B7%AF-DE.jpg',
            },
        },
    },
    fr: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761640952284/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_FR_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620531857-m9vlqa-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91-FR.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640995295/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_ES_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761623429187-y00c0k-compressed-M-D3M-01-%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761640952087/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_FR_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620539845-o5lv2n-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91-FR.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761640995411/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_FR_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761623438697-6qpku5-compressed-M-D3M-02-%E5%8D%95%E8%B7%AF.jpg',
            },
        },
    },
    it: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641547028/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_IT_%E5%8F%8C%E8%B7%AF_1.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620555905-67w61k-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91-IT.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641127648/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_IT_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761623395499-lv28he-compressed-%E5%8F%8C%E8%B7%AF-IT.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641546576/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_IT_%E5%8D%95%E8%B7%AF_1.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620562974-vch3fl-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91-IT.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761617464704/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_IT_%E5%8D%95%E8%B7%AF_1.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761623416798-umzsn0-compressed-M-D3M-02-%E5%8D%95%E8%B7%AF.jpg',
            },
        },
    },
    es: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641168638/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_ES_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620664161-ua7p1h-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91-ES.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641213617/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_ES_%E5%8F%8C%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761623451620-cjighq-compressed-M-D3M-01-%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1761641168402/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_PC_ES_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761620677983-kl5tfu-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91-ES.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1761641212939/%E5%88%86%E8%B7%AF%E6%8E%A7%E5%88%B6_%E6%89%8B%E5%8A%A8_M_ES_%E5%8D%95%E8%B7%AF_1_H.264.mp4',
                h5Poster: 'https://websiteoss.ecoflow.com/figma-uploads/1761623585134-3tirjf-compressed-M-D3M-02-%E5%8D%95%E8%B7%AF.jpg',
            },
        },
    },
    uk: {
        max: {
            double: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1765436892230/%E8%87%AA%E5%8A%A8.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286855287-jyp6sa-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1765437068310/%E8%87%AA%E5%8A%A8.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286907294-enwbcx-compressed-%E7%AC%AC%E4%B8%80%E4%B8%AA%E8%A7%86%E9%A2%91%E6%98%AF%E5%8F%8C%E8%B7%AF.jpg',
            },
            single: {
                pc: 'https://websiteoss.ecoflow.com/upload/video/1765436892006/%E6%89%8B%E5%8A%A8.mp4',
                pcPoster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286875442-evmgt4-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF%E8%A7%86%E9%A2%91.jpg',
                h5: 'https://websiteoss.ecoflow.com/upload/video/1765437068103/%E6%89%8B%E5%8A%A8.mp4',
                h5Poster:
                    'https://websiteoss.ecoflow.com/figma-uploads/1761286917103-m9ax27-compressed-%E7%82%B9%E5%87%BBtab%E5%88%87%E6%8D%A2%E5%90%8E%E6%98%AF%E5%8D%95%E8%B7%AF.jpg',
            },
        },
    },
};

videoLocaleMap.ca = videoLocaleMap.us;

type ImgItem = {
    pc: string;
    pad: string;
    h5: string;
};

type ImgOpenMap = Partial<
    Record<
        'us' | 'ca' | 'eu' | 'uk' | 'de' | 'fr' | 'it' | 'es',
        {
            double: ImgItem;
            single: ImgItem;
        }
    >
>;

export const imgLocaleOpenMap: ImgOpenMap = {
    us: {
        double: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758010710363-dsmpsp-compressed-%E5%8F%8C%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758010710363-dsmpsp-compressed-%E5%8F%8C%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1759041020750-a8c648-compressed-%E5%8F%8C%E8%B7%AFui%E7%95%8C%E9%9D%A2.png',
        },
        single: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758025754146-w3baim-compressed-%E5%8D%95%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1757754961073-cfcrxl-compressed-%E5%8D%95%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757754668840-z8hpr2-compressed-%E5%8D%95%E8%B7%AFui%E7%95%8C%E9%9D%A2.png',
        },
    },
    eu: {
        double: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758010710363-dsmpsp-compressed-%E5%8F%8C%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1758010710363-dsmpsp-compressed-%E5%8F%8C%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1759041020750-a8c648-compressed-%E5%8F%8C%E8%B7%AFui%E7%95%8C%E9%9D%A2.png',
        },
        single: {
            pc: 'https://websiteoss.ecoflow.com/figma-uploads/1758025754146-w3baim-compressed-%E5%8D%95%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            pad: 'https://websiteoss.ecoflow.com/figma-uploads/1757754961073-cfcrxl-compressed-%E5%8D%95%E8%B7%AF%E7%95%8C%E9%9D%A2.png',
            h5: 'https://websiteoss.ecoflow.com/figma-uploads/1757754668840-z8hpr2-compressed-%E5%8D%95%E8%B7%AFui%E7%95%8C%E9%9D%A2.png',
        },
    },
};

imgLocaleOpenMap.ca = imgLocaleOpenMap.us;
imgLocaleOpenMap.uk = imgLocaleOpenMap.eu;
imgLocaleOpenMap.de = imgLocaleOpenMap.eu;
imgLocaleOpenMap.fr = imgLocaleOpenMap.eu;
imgLocaleOpenMap.it = imgLocaleOpenMap.eu;
imgLocaleOpenMap.es = imgLocaleOpenMap.eu;

export default videoLocaleMap;
